<template>
	<div>
		<vue-draggable-resizable class="enterprise-detail" :w="420" h="auto" :z="9999" class-name-draggable="my-draggable-class" :resizable="false" ref="dragable" :style="{left: x + 'px', top: y + 'px'}"> 
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span class="title">{{ type == 3 ? model.projectName : model.title }} </span>
					<el-button style="float: right; margin-top:-5px; margin-right:-8px;" size="mini" circle icon="el-icon-close" @click="closeDetail"></el-button>
				</div>
				<div>
					<el-descriptions :column="2" v-if="detailBtn || type == 3"> 
						<el-descriptions-item label="法人代表" v-if="type == 1">{{ detail.legalPerson}}</el-descriptions-item>
						<el-descriptions-item label="电话" span="3" v-if="type == 1">{{ detail.phone}}</el-descriptions-item>
						<el-descriptions-item span="3" v-if="detail.morePhone && detail.morePhone != '-' && type == 1" label="更多电话">{{ detail.morePhone}}</el-descriptions-item>
						<el-descriptions-item label="邮箱" span="3" v-if="type == 1">{{ detail.email}}</el-descriptions-item>
						<el-descriptions-item span="3" v-if="detail.moreEmail && detail.moreEmail != '-' && type == 1" label="更多邮箱">{{ detail.moreEmail}}</el-descriptions-item> 
						<el-descriptions-item label="竣工时间" v-if="type == 2">{{ detail.completionTime}}</el-descriptions-item>
						<el-descriptions-item label="在营企业数量" v-if="type == 2">{{ detail.enterpriseNum}}</el-descriptions-item>
						<el-descriptions-item label="全年迁入企业" v-if="type == 2">{{ detail.moveIn}}</el-descriptions-item>
						<el-descriptions-item label="全年迁出企业" v-if="type == 2">{{ detail.moveOut}}</el-descriptions-item> 
						
							<el-descriptions-item label="总面积(亩)" v-if="type == 3">{{ model.size}}{{model.unit}}</el-descriptions-item>
							<el-descriptions-item label="土地用途" v-if="type == 3">{{ model.purpose}}</el-descriptions-item>
							<el-descriptions-item label="签订时间" v-if="type == 3">{{ model.time}}</el-descriptions-item>
							<el-descriptions-item label="投资来源地" v-if="type == 3">{{ model.area}}</el-descriptions-item>
							<el-descriptions-item label="土地使用权人" span="3" v-if="type == 3">
								<span class="curp" v-if="!model.sourceStockCode"  @click="routerlinkid('/enterprises',model.sourceStockCode)">{{model.owner}}</span>
								<span v-if="model.sourceStockCode">{{emptyStr(model.owner)}}</span>
							</el-descriptions-item>
							<el-descriptions-item label="投资主体" span="3" v-if="type == 3 && model.sourceEnterprise"> 
								<span class="curp" v-if="model.sourceStockCode!=''"  @click="routerlinkid('/enterprises',model.sourceStockCode)">{{model.sourceEnterprise}}</span>
								<span v-if="model.sourceStockCode==''">{{emptyStr(model.sourceEnterprise)}}</span> 
							</el-descriptions-item>
						<!-- 	<el-descriptions-item label="投资主体"   v-if="type == 3">{{ model.sourceEnterprise}}</el-descriptions-item>
							<el-descriptions-item label="投资来源地"   v-if="type == 3">{{ model.sourceArea}}</el-descriptions-item>
							 -->
						<el-descriptions-item label="地址" span="3" v-if="type != 3">{{model.address}}</el-descriptions-item>
						<el-descriptions-item label="导航" span="3" v-if="isNavigation">
							<el-button :type="navType == 1 ? 'primary' : 'default'" size="small" @click="onNavigation(1)">驾车</el-button>
							<el-button :type="navType == 2 ? 'primary' : 'default'" size="small" @click="onNavigation(2)">公交</el-button>
							<el-button :type="navType == 3 ? 'primary' : 'default'" size="small" @click="onNavigation(3)">骑行</el-button>
							<el-button :type="navType == 4 ? 'primary' : 'default'" size="small" @click="onNavigation(4)">步行</el-button>
						</el-descriptions-item>
					</el-descriptions>
					<div class="center" v-if="type != 3">
						<el-link :href="detailUrl" target="_blank" type="primary">>>点击查看更多信息</el-link>
					</div>
				</div>
			</el-card> 
		</vue-draggable-resizable> 
		<Navigation ref="navigation" @close="onCloseNavigation" v-if="showNavigation"></Navigation>
	</div>
</template>

<script>
	import Navigation from './navigation';
	export default {
		components: {
			Navigation
		},
		props: {
			type:Number,//1企业 2楼宇 3拿地
			model: Object,
			pixel: Object,
			token:String,
			isNavigation: {
				type: Boolean,
				default: true,
			}
		},
		watch: {
			model: {
				immediate: true,
				handler: function(newVal, oldVal) {
					this.userdata = this.getuseriformation();
					this.update(newVal);
					console.log(newVal)
				},
			},
			pixel: {
				immediate: true,
				handler: function(newVal, oldVal) {
					this.x = window.innerWidth / 2 - 395;
					this.y = window.innerHeight / 2 - 20;
					return;
					this.x = newVal.x - 395;
					this.y = newVal.y - 20;
				},
			}
		},
		data() {
			return {
				code: 0,
				x: 0,
				y: 0,
				detailList:[
					{name:"企业",url:'/#/enterprises?id=',ajaxurl:this.$api.cyl.map.mapdetail() + '?stockCode=',},
					{name:"楼宇",url:'/#/building?id=',ajaxurl:this.$api.park.building.detail() + "?id=",},
					{name:"拿地项目",url:'/#/building?id=',ajaxurl:this.$api.park.building.detail() + "?id=",},
				],
				detailBtn:false,
				curList:{},
				detail: {},
				detailUrl: '#',
				navType: 0,
				showNavigation: false,
				userdata: {},
			}
		},
		created() {
				this.userdata = this.getuseriformation();
				this.curList=this.detailList[this.type-1];
				console.log('curList',this.curList)
		},
		mounted() {
		},
		methods: {
			closeDetail() {
				this.$emit('close');
			},
			update(row) {
					var code=0;
				if(this.type == 1){
					code=row.code ;
				}else{
					code=row.id ;
				}
			 
				this.curList=this.detailList[this.type-1];
				if (this.$refs.dragable) {
					this.$refs.dragable.left = 0;
					this.$refs.dragable.top = 0;
				}

				this.detail = {};
				this.detailUrl = 	this.curList.url+ code; 
				let token = this.token,
					_this = this;
				console.log(token,code,this.model);
				if(this.type!=3){//拿地项目的没有详情页数据
					this.$axios.get(	this.curList.ajaxurl + code, {
						headers: {
							AuthToken: token
						}
					}).then(res => {
						res = res.data || {};
						if (res.success) {
							console.log(res.data);
							_this.detail = res.data;
							_this.detailBtn=true;
						}
					});
				}
				
			},
			onNavigation(type) {
				this.navType = type;
				this.showNavigation = true;
				this.$emit('navigation', type);
			},
			onCloseNavigation() {
				this.showNavigation = false;
				this.$emit('navigationclose');
			},
			onNavigationComplete(success) {
				console.log('complete', success);
				if (success) {
					this.$refs.navigation.onSuccess();
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.my-draggable-class {
		border: 0 !important;
	}

	.enterprise-detail {
		position: absolute;
		width: 440px;
		text-align: left;
		z-index: 9999;
		cursor: default;

		.title {
			font-size: 15px;
			font-weight: bold;
		}

		.center {
			text-align: center;
		}

	}
</style>
